import { JSONMap } from "models/ApiResponseModel";


export class AuthRoleModel {
    id: number;
    title: string;
    isActive: boolean;

    constructor(id: number, title: string, isActive: boolean) {
        this.id = id;
        this.title = title;
        this.isActive = isActive;
    }

    public static fromJson(json: any): AuthRoleModel {
        return new AuthRoleModel(
            json["id"],
            json["title"],
            json["isActive"] ?? true
        );
    }
}

export class AuthAccessModel {
    write: boolean;
    title: string;

    constructor(write: boolean, title: string) {
        this.write = write;
        this.title = title;
    }

    public static fromJson(json: any): AuthAccessModel {
        return new AuthAccessModel(
            json["write"],
            json["title"] ?? ""
        );
    }
}




export class AuthUserSimpleModel {
    id: number;
    userRoleId: number;
    userRoleName: string;
    email: string | null;
    userName: string;
    mobile: string;
    isActive: boolean;
    activationCode: string | null;

    constructor(
        id: number,
        userRoleId: number,
        userRoleName: string,
        email: string | null,
        userName: string,
        mobile: string,
        isActive: boolean,
        activationCode: string | null
    ) {
        this.id = id;
        this.userRoleId = userRoleId;
        this.userRoleName = userRoleName;
        this.email = email;
        this.userName = userName;
        this.mobile = mobile;
        this.isActive = isActive;
        this.activationCode = activationCode;
    }

    public static fromJson(json: any): AuthUserSimpleModel {
        return new AuthUserSimpleModel(
            json["id"],
            json["userRoleId"],
            json["userRoleName"],
            json["email"],
            json["userName"],
            json["mobile"],
            json["isActive"],
            json["activationCode"]
        );
    }
}


export class UserFilterPayload {
    Id: number = 0;
    Email: string = '';
    UserName: string = '';
    Mobile: string = '';
    IsActive: number = -1;
    UserRoleId: number = 0;
    constructor(
    ) {
    }
}

export class AuthUserGetPaload {
    reload?: number;
    pageNumber: number = 0;
    pageSize: number = 10;
    Filters?: UserFilterPayload;
}


export class AuthUserPayloadModel {
    Id: number;
    UserRoleId: number;
    UserName: string;
    Mobile: string;
    IsActive: boolean;
    Password: string;

    constructor(
        Id: number,
        UserRoleId: number,
        UserName: string,
        Mobile: string,
        IsActive: boolean,
        Password: string
    ) {
        this.Id = Id;
        this.UserRoleId = UserRoleId;
        this.UserName = UserName;
        this.Mobile = Mobile;
        this.IsActive = IsActive;
        this.Password = Password;
    }
}

export class AuthGeneralUserSimpleModel {
    id: number;
    userName: string;
    mainAgentNationalCode: string;
    userRoleId: number;
    baseStatusId: number;
    radAccountId: number;
    userRole: string;
    baseStatus: string;
    mobileNo: string;
    isActive: boolean;
    isConfirm: boolean;
    isLegal: boolean;
    confirmCode: string;

    constructor(
        id: number,
        userName: string,
        mainAgentNationalCode: string,
        userRoleId: number,
        baseStatusId: number,
        radAccountId: number,
        userRole: string,
        baseStatus: string,
        mobileNo: string,
        isActive: boolean,
        isConfirm: boolean,
        isLegal: boolean,
        confirmCode: string
    ) {
        this.id = id;
        this.userName = userName;
        this.mainAgentNationalCode = mainAgentNationalCode;
        this.userRoleId = userRoleId;
        this.baseStatusId = baseStatusId;
        this.radAccountId = radAccountId;
        this.userRole = userRole;
        this.baseStatus = baseStatus;
        this.mobileNo = mobileNo;
        this.isActive = isActive;
        this.isConfirm = isConfirm;
        this.isLegal = isLegal;
        this.confirmCode = confirmCode;
    }

    public static fromJson(json: any): AuthGeneralUserSimpleModel {
        return new AuthGeneralUserSimpleModel(
            json["id"],
            json["userName"],
            json["mainAgentNationalCode"],
            json["userRoleId"],
            json["baseStatusId"],
            json["radAccountId"],
            json["userRole"],
            json["baseStatus"],
            json["mobileNo"],
            json["isActive"],
            json["isConfirm"],
            json["isLegal"],
            json["ConfirmCode"]
        );
    }
}
export class GeneralUserFilterPayload {
    Id?: number = 0;
    UserName?: string = '';
    MobileNo?: string = '';
    IsActive?: number = -1;
    IsConfirm?: number = -1;
    IsLegal?: number = -1;
    UserRoleId?: number = 0;
    BaseStatusId?: number = 0;
    RadAccountId?: number = 0;
    IsAdmin?: number = 0;
    constructor(
    ) {
    }
}


export class AuthGeneralUserGetPaload {
    reload?: number;
    pageNumber: number = 0;
    pageSize: number = 10;
    Filters?: GeneralUserFilterPayload;
}


export class AuthGeneralUserPayloadModel {
    id: number;
    userRoleId: number;
    userName: string;
    mobileNo: string;
   isActive: boolean;
    isConfirm: boolean=true;
    isLegal: boolean;
    password: string;
    radAccountId: number;
    isAdmin: boolean=true;
    
    constructor(
        id: number,
        userRoleId: number,
        userName: string,
        mobileNo: string,
        isActive: boolean,
        isConfirm: boolean,
        isLegal: boolean,
        password: string,
        radAccountId: number,
        isAdmin: boolean,
    ) {
        this.id = id;
        this.userRoleId = userRoleId;
        this.userName = userName;
        this.mobileNo = mobileNo;
        this.isActive = isActive;
        this.isConfirm = isConfirm;
        this.isLegal = isLegal;
        this.password = password;
        this.radAccountId = radAccountId;
        this.isAdmin = isAdmin;
    }
}

export interface  UserLegalFilterPayload {
    id?: number ;
    userName?: string ;
    companyName?: string ;
    mobileNo?: string ;
    isActive?: number ;
    isConfirm?: number ;
    isLegal?: number ;
    userRoleId?: number ;
    baseStatusId?: number ;
    radAccountId?: number ;
  
}


export class AuthLegalUserGetPaload {
    isAdmin?: boolean;
    pageNumber?: number = 0;
    pageSize?: number = 10;
    Filters?: UserLegalFilterPayload;
}


export class AuthLegalUserSimpleModel {
     id: number;
    isAdmin: boolean;
    userRoleId: number;
    radAccountId: number;
    baseStatusId: number;
    userRole: string;
    baseStatus: string;
    userName: string;
    mobileNo: string;
    isActive: boolean;
    isConfirm: boolean;
    isLegal: boolean;
    confirmCode: string | null;
    companyName: string;
    password: string;
    repeatPassword: string;
   
    nationalId: number;
    mainAgentName: string;
    mainAgentPosition: string;
    radMainAgentId: string;
    mainAgentMobile: string;
    mainAgentNationalCode: string;
    
    radFinancialAgentId: string;
    financialAgentName: string;
    financialAgentPhone: string;
    financialAgentMobile: string;
    radSupportAgentId: string;
    supportAgentName: string;
    supportAgentPhone: string;
    supportAgentMobile: string;
   // Euqipments: { EquipmentId1: number|null, EquipmentId2: number|null,EquipmentId3: number|null, EquipmentId4: number|null, EquipmentId5: number|null, EquipmentId6: number|null, EquipmentId7: number|null };
       UserAddressList: AuthUserAddressSimpleModel[];

    defAddressId: number;
    equipmentId1: number;
    equipmentId2: number;
    equipmentId3: number;
    equipmentId4: number;
    equipmentId5: number;
    equipmentId6: number;
    equipmentId7: number;

    constructor(
        id: number,
        isAdmin: boolean,
        userRoleId: number,
        radAccountId: number,
        baseStatusId: number,
        userRole: string,
        baseStatus: string,
        userName: string,
        mobileNo: string,
        isActive: boolean,
        isConfirm: boolean,
        isLegal: boolean,
        confirmCode: string | null,
        companyName: string,
        password: string,
        repeatPassword: string,

        nationalId: number,
        mainAgentName: string,
        mainAgentPosition: string,
        radMainAgentId: string,
        mainAgentMobile: string,
        mainAgentNationalCode: string,
        radFinancialAgentId: string,
        financialAgentName: string,
        financialAgentPhone: string,
        financialAgentMobile: string,
        radSupportAgentId: string,
        supportAgentName: string,
        supportAgentPhone: string,
        supportAgentMobile: string,
    //    Euqipments: { EquipmentId1: number|null, EquipmentId2: number|null,EquipmentId3: number|null, EquipmentId4: number|null, EquipmentId5: number|null, EquipmentId6: number|null, EquipmentId7: number|null },
           UserAddressList: AuthUserAddressSimpleModel[],
 
        defAddressId: number,
        equipmentId1: number,
        equipmentId2: number,
        equipmentId3: number,
        equipmentId4: number,
        equipmentId5: number,
        equipmentId6: number,
        equipmentId7: number,        
      
    ) {
        this.id = id;
        this.isAdmin = isAdmin;
        this.userRoleId = userRoleId;
        this.radAccountId = radAccountId;
        this.baseStatusId = baseStatusId;
        this.userRole = userRole;
        this.baseStatus = baseStatus;
        this.userName = userName;
        this.mobileNo = mobileNo;
        this.isActive = isActive;
        this.isConfirm = isConfirm;
        this.isLegal = isLegal;
        this.confirmCode = confirmCode;
        this.companyName = companyName;
        this.password = password;
        this.repeatPassword = repeatPassword;
        
        this.nationalId = nationalId;
        this.mainAgentName = mainAgentName;
        this.mainAgentPosition = mainAgentPosition;
        this.radMainAgentId = radMainAgentId;
        this.mainAgentMobile = mainAgentMobile;
        this.mainAgentNationalCode = mainAgentNationalCode;
        this.radFinancialAgentId = radFinancialAgentId;
        this.financialAgentName = financialAgentName;
        this.financialAgentPhone = financialAgentPhone;
        this.financialAgentMobile = financialAgentMobile;
        this.radSupportAgentId = radSupportAgentId;
        this.supportAgentName = supportAgentName;
        this.supportAgentPhone = supportAgentPhone;
        this.supportAgentMobile = supportAgentMobile;
       // this.Euqipments = Euqipments;
        this.UserAddressList = UserAddressList;
        this.defAddressId = defAddressId;
        this.equipmentId1 = equipmentId1;
        this.equipmentId2 = equipmentId2;
        this.equipmentId3 = equipmentId3;
        this.equipmentId4 = equipmentId4;
        this.equipmentId5 = equipmentId5;
        this.equipmentId6 = equipmentId6;
        this.equipmentId7 = equipmentId7;
    }


    public static fromJson(json: any): AuthLegalUserSimpleModel {
        return new AuthLegalUserSimpleModel(
            json["id"],
            json["isAdmin"],
            json["userRoleId"],
            json["radAccountId"],
            json["baseStatusId"],
            json["userRole"],
            json["baseStatus"],
            json["userName"],
            json["mobileNo"],
            json["isActive"],
            json["isConfirm"],
            json["isLegal"],
            json["ConfirmCode"],
            json["companyName"],
            json["password"],
            json["repeatPassword"],

            json["nationalId"],
            json["mainAgentName"],
            json["mainAgentPosition"],
            json["radMainAgentId"],
            json["mainAgentMobile"],
            json["mainAgentNationalCode"],
            json["radFinancialAgentId"],
            json["financialAgentName"],
            json["financialAgentPhone"],
            json["financialAgentMobile"],
            json["radSupportAgentId"],
            json["supportAgentName"],
            json["supportAgentPhone"],
            json["supportAgentMobile"],
       //     json["Euqipments"],
            json["UserAddressList"],
            json["defAddressId"],
            json["equipmentId1"],
            json["equipmentId2"],
            json["equipmentId3"],
            json["equipmentId4"],
            json["equipmentId5"],
            json["equipmentId6"],
            json["equipmentId7"]
        );
    }
}

export class AuthLegalUserPayloadModel {
    id: number;
    isAdmin: boolean;
    userRoleId: number;
    radAccountId: number;
    baseStatusId: number;
    userRole: string;
    baseStatus: string;
    userName: string;
    mobileNo: string;
    isActive: boolean;
    isConfirm: boolean;
    isLegal: boolean;
    confirmCode: string | null;
    companyName: string;
    password: string;
    repeatPassword: string;
   
    nationalId: number;
    mainAgentName: string;
    mainAgentPosition: string;
    radMainAgentId: string;
    mainAgentMobile: string;
    mainAgentNationalCode: string;
    radFinancialAgentId: string;
    financialAgentName: string;
    financialAgentPhone: string;
    financialAgentMobile: string;
    radSupportAgentId: string;
    supportAgentName: string;
    supportAgentPhone: string;
    supportAgentMobile: string;
    UserAddressList: AuthUserAddressSimpleModel[];
    addressTypeId: number;
    defAddressId: number;
    equipmentId1: number;
    equipmentId2: number;
    equipmentId3: number;
    equipmentId4: number;
    equipmentId5: number;
    equipmentId6: number;
    equipmentId7: number;

    constructor(
        id: number,
        isAdmin: boolean,
        userRoleId: number,
        radAccountId: number,
        baseStatusId: number,
        userRole: string,
        baseStatus: string,
        userName: string,
        mobileNo: string,
        isActive: boolean,
        isConfirm: boolean,
        isLegal: boolean,
        confirmCode: string | null,
        companyName: string,
        password: string,
        repeatPassword: string,

        nationalId: number,
        mainAgentName: string,
        mainAgentPosition: string,
        radMainAgentId: string,
        mainAgentMobile: string,
        mainAgentNationalCode: string,
        radFinancialAgentId: string,
        financialAgentName: string,
        financialAgentPhone: string,
        financialAgentMobile: string,
        radSupportAgentId: string,
        supportAgentName: string,
        supportAgentPhone: string,
        supportAgentMobile: string,
        UserAddressList: AuthUserAddressSimpleModel[],
        addressTypeId: number,
        defAddressId: number,
        equipmentId1: number,
        equipmentId2: number,
        equipmentId3: number,
        equipmentId4: number,
        equipmentId5: number,
        equipmentId6: number,
        equipmentId7: number,        
      
    ) {
        this.id = id;
        this.isAdmin = isAdmin;
        this.userRoleId = userRoleId;
        this.radAccountId = radAccountId;
        this.baseStatusId = baseStatusId;
        this.userRole = userRole;
        this.baseStatus = baseStatus;
        this.userName = userName;
        this.mobileNo = mobileNo;
        this.isActive = isActive;
        this.isConfirm = isConfirm;
        this.isLegal = isLegal;
        this.confirmCode = confirmCode;
        this.companyName = companyName;
        this.password = password;
        this.repeatPassword = repeatPassword;
        
        this.nationalId = nationalId;
        this.mainAgentName = mainAgentName;
        this.mainAgentPosition = mainAgentPosition;
        this.radMainAgentId = radMainAgentId;
        this.mainAgentMobile = mainAgentMobile;
        this.mainAgentNationalCode = mainAgentNationalCode;
        this.radFinancialAgentId = radFinancialAgentId;
        this.financialAgentName = financialAgentName;
        this.financialAgentPhone = financialAgentPhone;
        this.financialAgentMobile = financialAgentMobile;
        this.radSupportAgentId = radSupportAgentId;
        this.supportAgentName = supportAgentName;
        this.supportAgentPhone = supportAgentPhone;
        this.supportAgentMobile = supportAgentMobile;
        this.UserAddressList = UserAddressList;
        this.addressTypeId = addressTypeId;
        this.defAddressId = defAddressId;
        this.equipmentId1 = equipmentId1;
        this.equipmentId2 = equipmentId2;
        this.equipmentId3 = equipmentId3;
        this.equipmentId4 = equipmentId4;
        this.equipmentId5 = equipmentId5;
        this.equipmentId6 = equipmentId6;
        this.equipmentId7 = equipmentId7;
    }

 
}
export class UserRealFilterPayload {
    id?: number ;
    userName?: string;
    firstName?: string ;
    lastName?: string ;
    mobileNo?: string;
    email?: string;
    introducerPerson?: string ;
    position?: string;
    membershipNo?: string ;
    nationalCode?: string ;
    educationalDegreeId?: number ;
    universityId?: number;
    introductionId?: number;
    isActive?: number;
    isConfirm?: number;
    isLegal?: number;
    userRoleId?: number ;
    baseStatusId?: number ;
    radAccountId?: number ;
    constructor(
    ) {
    }
}
export class AuthRealUserGetPaload {
    reload?: number;
    isAdmin?: boolean;
    pageNumber?: number = 0;
    pageSize?: number = 10;
    Filters?: UserRealFilterPayload;
}
export class AuthRealUserSimpleModel {
    id: number;
    isAdmin: boolean;
    userRoleId: number;
    radAccountId: number;
    baseStatusId: number;
    userRole: string;
    baseStatus: string;
    userName: string;
    mobileNo: string;
    isActive: boolean;
    isConfirm: boolean;
    isLegal: boolean;
    confirmCode: string | null;

    password: string;
    repeatPassword: string;

    firstName: string;
    lastName: string;
    birthDate:  Date | null;
    nationalCode: string;
    medicalNo: string;
    hasOfficePermit: boolean;
    graduatedYear: number;
    email: string;
    introducerPerson: string;
    position: string;
    phoneNo: string;
    membershipNo: string;
    medicalDocImgId: number;
    officePermitImgId: number;
    educationalDegreeId: number;
    educationalDegreeTitle: string;
    universityId: number;
    universityTitle: string;
    introductionId: number;
    introductionTitle: string;
    passportImageId: number;
    birthCertificateImageId: number;
       UserAddressList: AuthUserAddressSimpleModel[];
    defAddressId: number;
    equipmentId1: number;
    equipmentId2: number;
    equipmentId3: number;
    equipmentId4: number;
    equipmentId5: number;
    equipmentId6: number;
    equipmentId7: number;
    radMainAgentId: string;

    constructor(
        id: number,
        isAdmin: boolean,
        userRoleId: number,
        radAccountId: number,
        baseStatusId: number,
        userRole: string,
        baseStatus: string,
        userName: string,
        mobileNo: string,
        isActive: boolean,
        isConfirm: boolean,
        isLegal: boolean,
        confirmCode: string | null,

        password: string,
        repeatPassword: string,

        firstName: string,
        lastName: string,
        birthDate:  Date | null,
        nationalCode: string,
        medicalNo: string,
        hasOfficePermit: boolean,
        graduatedYear: number,
        email: string,
        introducerPerson: string,
        position: string,
        phoneNo: string,
        membershipNo: string,
        medicalDocImgId: number,
        officePermitImgId: number,
        educationalDegreeId: number,
        educationalDegreeTitle: string,
        universityId: number,
        universityTitle: string,
        introductionId: number,
        introductionTitle: string,
        passportImageId: number,
        birthCertificateImageId: number,
           UserAddressList: AuthUserAddressSimpleModel[],
        defAddressId: number,
        equipmentId1: number,
        equipmentId2: number,
        equipmentId3: number,
        equipmentId4: number,
        equipmentId5: number,
        equipmentId6: number,
        equipmentId7: number,
    radMainAgentId: string,
    ) {
        this.id = id;
        this.isAdmin = isAdmin;
        this.userRoleId = userRoleId;
        this.radAccountId = radAccountId;
        this.baseStatusId = baseStatusId;
        this.userRole = userRole;
        this.baseStatus = baseStatus;
        this.userName = userName;
        this.mobileNo = mobileNo;
        this.isActive = isActive;
        this.isConfirm = isConfirm;
        this.isLegal = isLegal;
        this.confirmCode = confirmCode;

        this.password = password;
        this.repeatPassword = repeatPassword;

        this.firstName = firstName;
        this.lastName = lastName;
        this.birthDate = birthDate;
        this.nationalCode = nationalCode;
        this.medicalNo = medicalNo;
        this.hasOfficePermit = hasOfficePermit;
        this.graduatedYear = graduatedYear;
        this.email = email;
        this.introducerPerson = introducerPerson;
        this.position = position;
        this.phoneNo = phoneNo;
        this.membershipNo = membershipNo;
        this.medicalDocImgId = medicalDocImgId;
        this.officePermitImgId = officePermitImgId;
        this.educationalDegreeId = educationalDegreeId;
        this.educationalDegreeTitle = educationalDegreeTitle;
        this.universityId = universityId;
        this.universityTitle = universityTitle;
        this.introductionId = introductionId;
        this.introductionTitle = introductionTitle;
        this.passportImageId = passportImageId;
        this.birthCertificateImageId = birthCertificateImageId;
        this.UserAddressList = UserAddressList;

        this.defAddressId = defAddressId;
        this.equipmentId1 = equipmentId1;
        this.equipmentId2 = equipmentId2;
        this.equipmentId3 = equipmentId3;
        this.equipmentId4 = equipmentId4;
        this.equipmentId5 = equipmentId5;
        this.equipmentId6 = equipmentId6;
        this.equipmentId7 = equipmentId7;
        this.radMainAgentId = radMainAgentId;
    }

    public static fromJson(json: any): AuthRealUserSimpleModel {
        return new AuthRealUserSimpleModel(
            json["id"],
            json["isAdmin"],
            json["userRoleId"],
            json["radAccountId"],
            json["baseStatusId"],
            json["userRole"],
            json["baseStatus"],
            json["userName"],
            json["mobileNo"],
            json["isActive"],
            json["isConfirm"],
            json["isLegal"],
            json["confirmCode"],
            json["password"],
            json["repeatPassword"],
            json["firstName"],
            json["lastName"],
            json["birthDate"],
            json["nationalCode"],
            json["medicalNo"],
            json["hasOfficePermit"],
            json["graduatedYear"],
            json["email"],
            json["introducerPerson"],
            json["position"],
            json["phoneNo"],
            json["membershipNo"],
            json["medicalDocImgId"],
            json["officePermitImgId"],
            json["educationalDegreeId"],
            json["educationalDegreeTitle"],
            json["universityId"],
            json["universityTitle"],
            json["introductionId"],
            json["introductionTitle"],
            json["passportImageId"],
            json["birthCertificateImageId"],

            json["UserAddressList"],
            json["defAddressId"],
            json["equipmentId1"],
            json["equipmentId2"],
            json["equipmentId3"],
            json["equipmentId4"],
            json["equipmentId5"],
            json["equipmentId6"],
            json["equipmentId7"],
            json["radMainAgentId"]
        );
    }
}
export class AuthRealUserPayloadModel {
   id: number;
    isAdmin: boolean;
    userRoleId: number;
    radAccountId: number;
    baseStatusId: number;
    userRole: string;
    baseStatus: string;
    userName: string;
    mobileNo: string;
    isActive: boolean;
    isConfirm: boolean;
    isLegal: boolean;
    confirmCode: string | null;

    password: string;
    repeatPassword: string;

    firstName: string;
    lastName: string;
    birthDate:  Date | null;
    nationalCode: string;
    medicalNo: string;
    hasOfficePermit: boolean;
    graduatedYear: number;
    email: string;
    introducerPerson: string;
    position: string;
    phoneNo: string;
    membershipNo: string;
    medicalDocImgId: number;
    officePermitImgId: number;
    educationalDegreeId: number;
    educationalDegreeTitle: string;
    universityId: number;
    universityTitle: string;
    introductionId: number;
    introductionTitle: string;
    passportImageId: number;
    birthCertificateImageId: number;
       UserAddressList: AuthUserAddressSimpleModel[];
    addressTypeId: number;
    defAddressId: number;
    equipmentId1: number;
    equipmentId2: number;
    equipmentId3: number;
    equipmentId4: number;
    equipmentId5: number;
    equipmentId6: number;
    equipmentId7: number;
    
    radMainAgentId: string;

    constructor(
        id: number,
        isAdmin: boolean,
        userRoleId: number,
        radAccountId: number,
        baseStatusId: number,
        userRole: string,
        baseStatus: string,
        userName: string,
        mobileNo: string,
        isActive: boolean,
        isConfirm: boolean,
        isLegal: boolean,
        confirmCode: string | null,

        password: string,
        repeatPassword: string,

        firstName: string,
        lastName: string,
        birthDate:  Date | null,
        nationalCode: string,
        medicalNo: string,
        hasOfficePermit: boolean,
        graduatedYear: number,
        email: string,
        introducerPerson: string,
        position: string,
        phoneNo: string,
        membershipNo: string,
        medicalDocImgId: number,
        officePermitImgId: number,
        educationalDegreeId: number,
        educationalDegreeTitle: string,
        universityId: number,
        universityTitle: string,
        introductionId: number,
        introductionTitle: string,
        passportImageId: number,
        birthCertificateImageId: number,
           UserAddressList: AuthUserAddressSimpleModel[],
        addressTypeId: number,
        defAddressId: number,
        equipmentId1: number,
        equipmentId2: number,
        equipmentId3: number,
        equipmentId4: number,
        equipmentId5: number,
        equipmentId6: number,
        equipmentId7: number,
        radMainAgentId: string,
    ) {
        this.id = id;
        this.isAdmin = isAdmin;
        this.userRoleId = userRoleId;
        this.radAccountId = radAccountId;
        this.baseStatusId = baseStatusId;
        this.userRole = userRole;
        this.baseStatus = baseStatus;
        this.userName = userName;
        this.mobileNo = mobileNo;
        this.isActive = isActive;
        this.isConfirm = isConfirm;
        this.isLegal = isLegal;
        this.confirmCode = confirmCode;

        this.password = password;
        this.repeatPassword = repeatPassword;

        this.firstName = firstName;
        this.lastName = lastName;
        this.birthDate = birthDate;
        this.nationalCode = nationalCode;
        this.medicalNo = medicalNo;
        this.hasOfficePermit = hasOfficePermit;
        this.graduatedYear = graduatedYear;
        this.email = email;
        this.introducerPerson = introducerPerson;
        this.position = position;
        this.phoneNo = phoneNo;
        this.membershipNo = membershipNo;
        this.medicalDocImgId = medicalDocImgId;
        this.officePermitImgId = officePermitImgId;
        this.educationalDegreeId = educationalDegreeId;
        this.educationalDegreeTitle = educationalDegreeTitle;
        this.universityId = universityId;
        this.universityTitle = universityTitle;
        this.introductionId = introductionId;
        this.introductionTitle = introductionTitle;
        this.passportImageId = passportImageId;
        this.birthCertificateImageId = birthCertificateImageId;
        this.UserAddressList = UserAddressList;
        this.addressTypeId = addressTypeId;

        this.defAddressId = defAddressId;
        this.equipmentId1 = equipmentId1;
        this.equipmentId2 = equipmentId2;
        this.equipmentId3 = equipmentId3;
        this.equipmentId4 = equipmentId4;
        this.equipmentId5 = equipmentId5;
        this.equipmentId6 = equipmentId6;
        this.equipmentId7 = equipmentId7;
        this.radMainAgentId = radMainAgentId;
    }

}



export class UserAddressFilterPayload {
    id?: number = 0;
    userId?: number = 0;
    areaId?: number = 0;
    zoneId?: number = 0;
    street?: string = '';
    number?: number = 0;
    unit?: number = 0;
    floor?: number = 0;
    postalCode?: string = '';
    boxNumber?: string = '';
    typeId?: number = 0
    isActive?: number = -1;
}
export class AuthUserAddressGetPaload {
    reload?: number;
    pageNumber?: number = 0;
    pageSize?: number = 10;
    Filters?: UserAddressFilterPayload;
}
export class AuthUserAddressSimpleModel {
    id: number;
    userId: number;
    areaId: number;
    area: string;
    zoneId: number;
    zone: string;
    street: string;
    number: number;
    unit: number;
    floor: number;
    postalCode: string;
    boxNumber: string;
    typeId: number;
    isActive: boolean;
    constructor(
        id: number,
        userId: number,
        areaId: number,
        area: string,
        zoneId: number,
        zone: string,
        street: string,
        isActive: boolean,
        number: number,
        unit: number,
        floor: number,
        postalCode: string,
        boxNumber: string,
        typeId: number,
    ) {
        this.id = id;
        this.userId = userId;
        this.areaId = areaId;
        this.area = area;
        this.zoneId = zoneId;
        this.zone = zone;
        this.street = street;
        this.isActive = isActive;
        this.number = number;
        this.unit = unit;
        this.floor = floor;
        this.postalCode = postalCode;
        this.boxNumber = boxNumber;
        this.typeId = typeId;
    }

    public static fromJson(json: any): AuthUserAddressSimpleModel {
        return new AuthUserAddressSimpleModel(
            json["id"],
            json["userId"],
            json["areaId"],
            json["area"],
            json["zoneId"],
            json["zone"],
            json["street"],
            json["isActive"],
            json["number"],
            json["unit"],
            json["floor"],
            json["postalCode"],
            json["boxNumber"],
            json["typeId"]
        );
    }

    public static default(userId: number,typeId: number): AuthUserAddressSimpleModel {
        return new AuthUserAddressSimpleModel(
            0,
            userId,
            0,
            "",
            0,
            "",
           "",
           true,
            0,
           0,
            0,
            "",
            "",
            typeId
        );
    }
}


export class AuthUserAddressPayloadModel {
    id: number;
    userId: number;
    areaId: number;
    zoneId: number;
    street: string;
    number: number;
    unit: number;
    floor: number;
    postalCode: string;
    boxNumber: string;
    typeId: number;
    isActive: boolean;
    constructor(
        id: number,
        userId: number,
        areaId: number,
        zoneId: number,
        street: string,
        isActive: boolean,
        number: number,
        unit: number,
        floor: number,
        postalCode: string,
        boxNumber: string,
        typeId: number,
    ) {
        this.id = id;
        this.userId = userId;
        this.areaId = areaId;
        this.zoneId = zoneId;
        this.street = street;
        this.isActive = isActive;
        this.number = number;
        this.unit = unit;
        this.floor = floor;
        this.postalCode = postalCode;
        this.boxNumber = boxNumber;
        this.typeId = typeId;
    }
}

export class UserStatusFilterPayload {
    Id?: number ;
    userId?: number;
    prevStatusId?: number ;
    newStatusId?: number ;
    isActive?: number ;
    constructor(
    ) {
    }
}
export class AuthUserStatusGetPaload {
    reload?: number;
    pageNumber?: number = 0;
    pageSize?: number = 10;
    Filters?: UserStatusFilterPayload;
}
export class AuthUserStatusSimpleModel {
    id: number;
    userId: number;
    radAccountId?: number;
    prevStatusId: number;
    newStatusId: number;
    prevStatusTitle: string;
    newStatusTitle: string;
    description: string;
    isActive: boolean;
    constructor(
        id: number,
        userId: number,
        radAccountId: number,
        prevStatusId: number,
        newStatusId: number,
        prevStatusTitle: string,
        newStatusTitle: string,
        description: string,
        isActive: boolean,
    ) {
        this.id = id;
        this.userId = userId;
        this.radAccountId = radAccountId;
        this.prevStatusId = prevStatusId;
        this.newStatusId = newStatusId;
        this.prevStatusTitle = prevStatusTitle;
        this.newStatusTitle = newStatusTitle;
        this.description = description;
        this.isActive = isActive;
    }

    public static fromJson(json: any): AuthUserStatusSimpleModel {
        return new AuthUserStatusSimpleModel(
            json["id"],
            json["userId"],
            json["radAccountId"],
            json["prevStatusId"],
            json["newStatusId"],
            json["prevStatusTitle"],
            json["newStatusTitle"],
            json["description"],
            json["isActive"]
        );
    }
} 
export class AuthUserStatusPayloadModel {
    id: number;
    userId: number;
    radAccountId?: number;
    prevStatusId: number;
    newStatusId: number;
    description: string;
    isActive: boolean;
    radMainAgentId?: number;
    radFinancialAgentId?: number;
    radSupportAgentId?: number;
    constructor(
        id: number,
        userId: number,
        radAccountId: number,
        prevStatusId: number,
        newStatusId: number,
        description: string,
        isActive: boolean,
        radMainAgentId: number,
        radFinancialAgentId: number,
        radSupportAgentId: number,
    ) {
        this.id = id;
        this.userId = userId;
        this.radAccountId = radAccountId;
        this.prevStatusId = prevStatusId;
        this.newStatusId = newStatusId;
        this.description = description;
        this.isActive = isActive;
        this.radMainAgentId = radMainAgentId;
        this.radFinancialAgentId = radFinancialAgentId;
        this.radSupportAgentId = radSupportAgentId;
    }

} 